module.exports = __webpack_public_path__ + "img/Trolley.69927c02.png";